export const validateEmail = (v: string) => {
  // 英数字@英数字.英数字2文字以上
  return (
    !!/^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/.test(v) || "正しく入力してください"
  );
};

export const validateEmailValidatonCode = (v: string) => {
  // 数字4桁
  return !!/^\d{4}$/.test(v) || "4桁のコードを入力してください";
};

export const validatePasswordLength = (v: string) => {
  // 10文字以上
  return !!(v.length >= 10) || "パスワードは10文字以上入力してください。";
};

export const validateAdminPasswordLength = (v: string) => {
  // 8文字以上
  return !!(v.length >= 8) || "パスワードは8文字以上入力してください。";
};

const validateMfaCode = (v: string) => {
  // 数字6桁
  return !!/^\d{6}$/.test(v) || "正しく入力してください";
};

const validateMfaPhoneNumber = (v: string) => {
  // +810123456789の形式チェック
  return !!/^\+\d{12}$/.test(v) || "正しく入力してください";
};

const validatePersonalInfoLastName = (s: string) => {
  // 全角1-50文字
  return (
    /^[a-zA-Zぁ-んァ-ヶー一-龯々]{1,50}$/.test(s) || "姓を漢字、ひらがな、カタカナ、アルファベットで入力してください"
  );
};

const validatePersonalInfoFirstName = (s: string) => {
  // 全角1-50文字
  return (
    /^[a-zA-Zぁ-んァ-ヶー一-龯々]{1,50}$/.test(s) || "名を漢字、ひらがな、カタカナ、アルファベットで入力してください"
  );
};

const validatePersonalInfoLastNameKana = (s: string) => {
  // 全角カナ1-50文字
  // eslint-disable-next-line no-irregular-whitespace
  return /^[ァ-ヴー　]{1,50}$/.test(s) || "セイをカタカナで入力してください";
};

const validatePersonalInfoFirstNameKana = (s: string) => {
  // 全角カナ1-50文字
  // eslint-disable-next-line no-irregular-whitespace
  return /^[ァ-ヴー　]{1,50}$/.test(s) || "メイをカタカナで入力してください";
};

const validateTransferInfoAccountHolderName = (s: string) => {
  // 全角カナ1-100文字
  // eslint-disable-next-line no-irregular-whitespace
  return /^[ァ-ヴー　]{1,100}$/.test(s) || "メイをカタカナで入力してください";
};

const validatePersonalInfoBirthYear = (s: string) => {
  return s !== "" || "年を正しく入力してください";
};

const validatePersonalInfoBirthMonth = (s: string) => {
  return s !== "" || "月を正しく入力してください";
};

const validatePersonalInfoBirthDay = (s: string) => {
  return s !== "" || "日を正しく入力してください";
};

const validatePersonalInfoBirthDateAsDate = (s: string) => {
  return IsValidDate(s) || "生年月日の入力が正しくありません";
};

const validatePersonalInfoBirthDateAs18YearsOrOlder = (s: string) => {
  return GetElapsedFullYears(s) >= 18 || "満18歳以上の方のみ登録できます";
};

const validatePersonalInfoPhoneNumber = (s: string) => {
  // 0始まりの数字10,11文字
  return /^0[0-9]{9,10}$/.test(s) || "電話番号を半角数字で入力してください";
};

const validatePersonalInfoPostCode = (s: string) => {
  // 数字7文字
  return /^[0-9]{7}$/.test(s) || "郵便番号を半角数字で入力してください";
};

const validatePersonalInfoPrefecture = (s: string) => {
  return s !== "" || "都道府県を正しく入力してください";
};

const validatePersonalInfoCity = (s: string) => {
  // 1-100文字
  return /^.{1,100}$/.test(s) || "市区町村を正しく入力してください";
};

const validatePersonalInfoBlock = (s: string) => {
  // 1-100文字
  return /^.{1,100}$/.test(s) || "番地を正しく入力してください";
};

const validatePersonalInfoBuilding = (s: string) => {
  // 0-100文字 (未入力OK)
  return /^.{0,100}$/.test(s) || "建物名・部屋番号を正しく入力してください";
};

export const validateLibraryTitle = (s: string) => {
  // 1-20文字
  return /^.{1,20}$/.test(s) || "セレクション名を20文字以内で入力してください";
};

export const validateLibrarySummary = (s: string) => {
  // 0-30文字
  return /^.{1,60}$/.test(s) || "セレクション概要を60文字以内で入力してください";
};

const validateTalkRoomName = (s: string) => {
  // 1-20文字
  return /^.{1,20}$/.test(s) || "1〜20文字で入力してください";
};

const validateTalkRoomDescription = (s: string) => {
  // 0-30文字
  return /^.{0,30}$/.test(s) || "30文字以内で入力してください";
};

const validateReceiptName = (s: string) => {
  // 1-100文字
  return /^.{1,100}$/.test(s) || "100文字以内で入力してください";
};

const validateStepDeliveryName = (s: string) => {
  // 1-100文字
  return /^.{1,100}$/.test(s) || "100文字以内で入力してください";
};

export const loginEmailRules = [validateEmail];
export const loginPasswordRules = [validatePasswordLength];
export const adminLoginPasswordRules = [validateAdminPasswordLength];
export const emailValidationCodeRules = [validateEmailValidatonCode];
export const mfaCodeRules = [validateMfaCode];
export const mfaPhoneNumberRules = [validateMfaPhoneNumber];

export const personalInfoLastNameRules = [validatePersonalInfoLastName];
export const personalInfoFirstNameRules = [validatePersonalInfoFirstName];
export const personalInfoLastNameKanaRules = [validatePersonalInfoLastNameKana];
export const personalInfoFirstNameKanaRules = [validatePersonalInfoFirstNameKana];
export const transferInfoAccountHolderNameRules = [validateTransferInfoAccountHolderName];
export const personalInfoBirthYearRules = [validatePersonalInfoBirthYear];
export const personalInfoBirthMonthRules = [validatePersonalInfoBirthMonth];
export const personalInfoBirthDayRules = [validatePersonalInfoBirthDay];
export const personalInfoBirthDateRules = [
  validatePersonalInfoBirthDateAsDate,
  validatePersonalInfoBirthDateAs18YearsOrOlder,
];
export const personalInfoPhoneNumberRules = [validatePersonalInfoPhoneNumber];
export const personalInfoPostCodeRules = [validatePersonalInfoPostCode];
export const personalInfoPrefectureRules = [validatePersonalInfoPrefecture];
export const personalInfoCityRules = [validatePersonalInfoCity];
export const personalInfoBlockRules = [validatePersonalInfoBlock];
export const personalInfoBuildingRules = [validatePersonalInfoBuilding];

export const libraryTitleRules = [validateLibraryTitle];
export const librarySummaryRules = [validateLibrarySummary];
export const talkRoomNameRules = [validateTalkRoomName];
export const talkRoomDescriptionRules = [validateTalkRoomDescription];

export const receiptEmailRules = [validateEmail];
export const receiptNameRules = [validateReceiptName];
export const testDeliverEmailRules = [validateEmail];
export const stepDeliveryNameRules = [validateStepDeliveryName];

export const emailRules = [validateEmail];

export const validateRules = (v: string, rules: ((v: string) => boolean | string)[]) => {
  for (const rule of rules) {
    const result = rule(v);
    if (typeof result === "string") {
      return result;
    }
  }
  return true;
};

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    validateRules: (v: string, rules: ((v: string) => boolean | string)[]) => boolean | string;
    loginEmailRules: ((v: string) => boolean | string)[];
    loginPasswordRules: ((v: string) => boolean | string)[];
    adminLoginPasswordRules: ((v: string) => boolean | string)[];
    emailValidationCodeRules: ((v: string) => boolean | string)[];
    mfaCodeRules: ((v: string) => boolean | string)[];
    mfaPhoneNumberRules: ((v: string) => boolean | string)[];
    personalInfoLastNameRules: ((v: string) => boolean | string)[];
    personalInfoFirstNameRules: ((v: string) => boolean | string)[];
    personalInfoLastNameKanaRules: ((v: string) => boolean | string)[];
    personalInfoFirstNameKanaRules: ((v: string) => boolean | string)[];
    transferInfoAccountHolderNameRules: ((v: string) => boolean | string)[];
    personalInfoBirthYearRules: ((v: string) => boolean | string)[];
    personalInfoBirthMonthRules: ((v: string) => boolean | string)[];
    personalInfoBirthDayRules: ((v: string) => boolean | string)[];
    personalInfoBirthDateRules: ((v: string) => boolean | string)[];
    personalInfoPhoneNumberRules: ((v: string) => boolean | string)[];
    personalInfoPostCodeRules: ((v: string) => boolean | string)[];
    personalInfoPrefectureRules: ((v: string) => boolean | string)[];
    personalInfoCityRules: ((v: string) => boolean | string)[];
    personalInfoBlockRules: ((v: string) => boolean | string)[];
    personalInfoBuildingRules: ((v: string) => boolean | string)[];
    libraryTitleRules: ((v: string) => boolean | string)[];
    librarySummaryRules: ((v: string) => boolean | string)[];
    talkRoomNameRules: ((v: string) => boolean | string)[];
    talkRoomDescriptionRules: ((v: string) => boolean | string)[];
    receiptEmailRules: ((v: string) => boolean | string)[];
    receiptNameRules: ((v: string) => boolean | string)[];
    testDeliverEmailRules: ((v: string) => boolean | string)[];
    stepDeliveryNameRules: ((v: string) => boolean | string)[];
    emailRules: ((v: string) => boolean | string)[];
  }
}
